import api from "./axiosInstance";

export const getBookings = async (limit, offset) => {
  const response = await api.get(`api/v1/bookings/?limit=${limit}&offset=${offset}`);
  return response.data;
};

export const getBookingById = async (id) => {
  const response = await api.get(`api/v1/bookings/${id}/`);
  return response.data;
};

export const createBookings = async (payload) => {
  const response = await api.post(
    "api/v1/bookings/",
    payload
  );
  return response.data;
};

export const deleteBookings = async (id) => {
  await api.delete(`api/v1/bookings/${id}/`);
};

export const getBookingsByArtist = async (artistId) => {
  const res = await api.get(`api/v1/bookings/`, {
    params: {
      artist: artistId,
    },
  });
  return res.data;
};


export const updateBookings = async (id, payload) => {
  const response = await api.patch(
    `api/v1/bookings/${id}/`,
    payload
  );
  return response.data;
};